import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";

import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepSpecific from "../../../../../../hooks/useStepSpecific";
import React from "react";
import { createFormalValidationFromSchema } from "../../../../../../yup/utils/yupUtils";
import { createAdditionalDocDetailsValidationSchemas } from "../../../../../../yup/additionalDoc/AdditionalDocDetailsValidationSchemas";
import { initialRudiAdditionalDocApplication } from "../../../../../../init/rudiAdditionalDocInitialValues";
import {
  completeAdditionalDocDetailStep,
  setStepAdditionalDocDetailEdited,
} from "../../../../../../store/redux/slice/Forms/rudiAdditionalDocForm";
import AdditionalDocStepDetails from "./AdditionalDocStepDetails";

const RudiAdditionalDocStepDetails = () => {
  const rudiAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.RudiAdditionalDocForm;
  });

  const fullSchema = createAdditionalDocDetailsValidationSchemas;
  const formalSchema = createFormalValidationFromSchema(fullSchema);

  const { onSubmit, methods } = useStepSpecific(
    rudiAdditionalDocForm.additionalDocDetail,
    rudiAdditionalDocForm.id,
    baseEndpointPaths.rudiAdditionalDoc,
    formalSchema,
    setStepAdditionalDocDetailEdited,
    completeAdditionalDocDetailStep,
    initialRudiAdditionalDocApplication,
  );

  useFormReset("RUDI_ADDITIONAL_DOCUMENTS", rudiAdditionalDocForm.additionalDocDetail, methods.reset);

  return (
    <AdditionalDocStepDetails
      fullSchema={fullSchema}
      formalSchema={formalSchema}
      methods={methods}
      onSubmit={onSubmit}
    />
  );
};
export default RudiAdditionalDocStepDetails;
